import { isStr } from 'lib/util/index'

/**
 * Lightens `color` according to a `coefficient`.
 *
 * @param {string} color        the color to lighten
 * @param {number} coefficient  multiplier in the range 0 - 1
 * @returns {string|null}
 */
export const lighten = (color, coefficient) => {
  const targetColor = color?.includes?.('#')
    ? color
    : null

  return !targetColor
    ? null
    : `#${[1, 3, 5]
      .map(s => parseInt(targetColor.substring(s, s + 2), 16))
      .map(c => c + ((255 - c) * coefficient))
      .map(c => Math.trunc(c).toString(16).padStart(2, '0'))
      .join('')}`
}

/**
 * Returns the quarter value of `value`, be it a number or a percentage string.
 *
 * @param {number|`${number}%`} value   a number or percentage string
 * @returns {number|`${number}%`}
 */
export const quarter = (value = 0) => (isStr(value)
  ? `${parseFloat(value.replace('%', '')) / 4}%`
  : value / 4)
